export enum StepState {
  COMPLETED = 'completed',
  CURRENT = 'current',
  FUTURE = 'future'
}
